<template>
  <div class="bag-wrapper">
    <div @click.stop="toggle(true)">
      <div class="iconwrapper">
        <button
          v-if="!open"
          id="bagButton"
          class="bag-wrapper-button -stripped -add-focus-box"
          aria-controls="bagPreview"
          aria-haspopup="true"
          aria-label="shopping bag"
          @click.stop="toggle(true)"
          tabindex="0"
        >
          <span role="status">
            <BagIcon
            :color="Globals.colors.primary"
            :size="18"
            :active="counter > 0"
            :count="counter"
          /></span>
        </button>
        <button v-else class="btn -stripped" @click.stop="toggle(false)">
          <div class="icon-close">
            <span></span>
            <span></span>
          </div>
        </button>
      </div>
    </div>
    <LoginNugde :bagOpen="open" @login-clicked="toggle(true, 'Account')" />
  </div>
</template>

<script>
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import BagIcon from '@/Scripts/components/shared/svg/Assets/Bag.vue';
const LoginNugde = () => import('@/Scripts/components/layout/Header/Assets/BagIconLoginNugde.vue');

export default {
  name: 'BagIconController',
  mixins: [siteInfo],
  components: {
    BagIcon,
    LoginNugde

  },
  model: {
    prop: 'open',
    event: 'toggle'
  },
  props: {
    open: Boolean,
    counter: Number
  },
  methods: {
    toggle (val, drawer) {
      if (drawer) {
        this.$emit('set-drawer', drawer);
      }
      this.$emit('toggle', val);
    }
  }

};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";

button.bag-wrapper-button {
    width: rem(18px);
    height: rem(18px);
  }

.bag-wrapper {
  cursor: pointer;
  position: relative;
  pointer-events: visible;
  padding-right: 9px;
  padding-left: 18px;
  text-align: right;
  pointer-events: visible;

  @include media-breakpoint-up(lg) {
    padding-right: 0;
  }

  .bag-indicator {
    @include font-responsive(smallest, regular, small-caps);
    text-align: center;
    line-height: 11px;
    position: absolute;
    z-index: 10;
    top: 6px;
    right: 4px;
    width: 10px;
    height: 10px;
    color: $white;
    background-color: $black;
    border-radius: 50%;
    pointer-events: none;
    user-select: none;
    transform: scale(0.5);
  }

  svg {
    height: rem(18px);
    width: rem(18px);
    text {
      letter-spacing: -0.03em;
    }
  }
}
</style>
